export function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export function storage (persistant) {
  return persistant ? window.localStorage : window.sessionStorage
}

export function wait (timer) {
  return new Promise(resolve => {
    setTimeout(() => resolve(), timer || 3000)
  })
}

export function findIndexById (items, id) {
  return items.findIndex(item => item._id == id)
}

export function removeItemById (items, id) {
  const index = findIndexById(items, id)

  items.splice(index, 1)
}

export function updateItemById (items, model) {
  const index = findIndexById(items, model._id)

  Object.keys(items[index]).forEach(property => {
    items[index][property] = model[property]
  })
}

export function ucfirst (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export function camelize (str) {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
    return index === 0 ? word.toLowerCase() : word.toUpperCase()
  }).replace(/\s+/g, '')
}

export function currency (value) {
  return 'R$ ' + parseFloat(value).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}

export function kilogram (value) {
  return parseFloat(value).toLocaleString('pt-BR', {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3
  }) + ' kg'
}

export function strLimit (value, limit = 15, finalStr = '...') {
  return value.length > limit ? value.substr(0, limit).trim() + finalStr : value
}

export function diff (currentDate, oldDate, diffBy) {
  const currentDateTimestamp = new Date(currentDate)
  const oldDateTimestamp = new Date(oldDate)
  const divisors = {
    minutes: 60000,
  }

  return parseInt((currentDateTimestamp - oldDateTimestamp) / divisors[diffBy])
}

export function percent (value) {
  return parseFloat(value).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) + '%'
}



// WEBPACK FOOTER //
// ./src/config/functions.js